import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import WebFont from "webfontloader";
import { polyfill } from "seamless-scroll-polyfill";
import "../src/theme/styleFonts.css"
/* import "../src/theme/font/GothamBold.ttf"
import "../src/theme/font/GothamBook.ttf"
 */
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import I18nextConfig from './utilities/translations/config/I18nextConfig'

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>

  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
